import { render } from "./letter-attachment.vue?vue&type=template&id=a4491b94"
import script from "./letter-attachment.vue?vue&type=script&lang=js"
export * from "./letter-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__